/* eslint-disable no-unused-vars */
import { HTMLAttributes } from 'react'
import Link from 'next/link'

import Button from '@/components/base/Button'
import Image from '@/components/base/Image'
import SVGIcon from '@/components/base/SVGIcon'
import Typography, { TypographyProps } from '@/components/base/Typography'

import { cn } from '@/lib/utils'
import { WPImage, WPLink } from '@/types'

export type PostCardProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    type: string
    color: string
    image: WPImage
    overline: string
    paragraph: string
    title: string
    title_variant: TypographyProps['variant']
    title_component: TypographyProps['component']
    link: WPLink
  }>

const PostCard = ({
  type,
  color,
  image,
  overline,
  paragraph,
  title,
  title_variant,
  title_component,
  link,
  className,
  ...props
}: PostCardProps) => {
  return (
    <div
      className={cn([
        'grid h-full grid-rows-[auto,_auto,_1fr] items-start gap-y-[2rem] rounded-[3rem] bg-white p-[2rem] md:min-h-[54rem]',
        className
      ])}
      {...props}
    >
      <div className="aspect-h-[230] aspect-w-[380] rounded-[1.5rem] bg-dark-blue">
        {image ? (
          <Link href={link?.url || '/'}>
            <Image
              source={image}
              fill
              fit="cover"
              className="rounded-[1.5rem]"
            />
          </Link>
        ) : null}
      </div>

      {title || paragraph || overline ? (
        <div className="grid items-start gap-y-[1rem]">
          {overline ? (
            <Typography variant="label">{overline}</Typography>
          ) : null}

          {/* {title ? (
            <Typography variant={title_variant} component={title_component}>
              {title}
            </Typography>
          ) : null} */}

          {title ? (
            <h6 className="font-garet text-s-h6 lg:text-d-h6">
              <Link href={link?.url || '/'}>{title}</Link>
            </h6>
          ) : null}

          {paragraph ? (
            <Typography variant="body" paragraph className="text-medium-blue">
              {paragraph}
            </Typography>
          ) : null}
        </div>
      ) : null}

      {link ? (
        <div className="flex">
          <Button
            variant="link"
            asChild
            startIcon={
              <SVGIcon
                symbol="arrow-right-icon"
                className="h-[1.1rem] w-[0.6rem] shrink-0 fill-heading"
              />
            }
          >
            <Link href={link.url}>
              <span data-label={link.title}>
                <Typography variant="label">{link.title}</Typography>
              </span>
            </Link>
          </Button>
        </div>
      ) : null}
    </div>
  )
}

export default PostCard
